import React from 'react'

function Privacy() {
    return (
        <div className='w-full min-h-screen  py-12'>
            <div className='container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl'>
                {/* Header */}
                <div className='mb-10 text-center'>
                    <h1 className='text-4xl md:text-5xl font-bold text-blue-500 mb-4'>
                        Términos y Condiciones
                    </h1>
                    <p className='text-lg text-gray-600 max-w-3xl mx-auto'>
                        Al marcar la casilla de términos y condiciones, usted acepta todas las condiciones descritas a continuación.
                    </p>
                </div>

                {/* Contenido principal */}
                <div className='bg-white rounded-2xl shadow-lg p-8 md:p-10 space-y-10'>
                    
                    {/* Sección 1: Condiciones generales */}
                    <section>
                        <h2 className='text-2xl md:text-3xl font-bold text-blue-700 mb-6 flex items-center gap-3'>
                            <span className='bg-blue-100 text-blue-700 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold'>1</span>
                            Condiciones para Nuestros Usuarios
                        </h2>
                        
                        <div className='space-y-4'>
                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Al momento de la inscripción en el taller, cada usuario confirma tener una condición de salud compatible con la actividad física.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    En caso de tener alguna condición médica, es responsabilidad del usuario consultar a su médico por la posibilidad de realizar ejercicios en nuestros recintos.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Es importante e imprescindible que, si durante la práctica del ejercicio siente alguna molestia o anomalía física, detenga su actividad y acuda a la consulta de un médico.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Cada usuario deberá traer su propio candado a fin de resguardar sus pertenencias en los casilleros habilitados. La Corporación Municipal de Deportes no se hará responsable por las pérdidas de pertenencias en caso de no cumplirse este punto.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Una vez inscrito en la actividad de preferencia, <strong>no habrá devolución de dinero</strong>, salvo la presentación de un certificado médico al inicio del taller. Este trámite se realizará solo una vez durante el año.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Las suspensiones de clases por motivos climáticos o ambientales declarados para la comuna de Ñuñoa o Región Metropolitana por organismos gubernamentales <strong>no son recuperables</strong>.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Las clases coincidentes con días feriados <strong>no son recuperables</strong>.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Las clases <strong>no son recuperables</strong>, ya que es responsabilidad del usuario asistir en el horario y día acordado de manera previa.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Divider */}
                    <div className='border-t border-gray-200'></div>

                    {/* Sección 2: Prohibiciones */}
                    <section>
                        <h2 className='text-2xl md:text-3xl font-bold text-red-700 mb-6 flex items-center gap-3'>
                            <span className='bg-red-100 text-red-700 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold'>⚠️</span>
                            Prohibiciones y Sanciones
                        </h2>
                        
                        <div className='space-y-4'>
                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    Está <strong>prohibida la comercialización</strong> u ofrecer cualquier tipo de servicios por medio de folletos y afiches dentro de las instalaciones, incluida el área del estacionamiento. De ser sorprendido, no podrá ingresar nuevamente a nuestras dependencias.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    <strong>No se permite el ingreso y consumo de bebidas alcohólicas ni estupefacientes</strong> a nuestro recinto. De ser sorprendido, no podrá ingresar nuevamente a nuestras dependencias.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    Está <strong>terminantemente prohibido el ingreso de personas portando armas</strong> de cualquier tipo. De ser sorprendido, la corporación tiene la responsabilidad de informar a Carabineros.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    No se permite filmar o fotografiar en el interior de las dependencias deportivas, salvo mediante autorización expresa de la administración.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    Está <strong>prohibido fumar</strong> en las instalaciones de la corporación.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-red-50 p-4 rounded-lg border-l-4 border-red-500'>
                                <span className='text-red-600 text-xl mt-1'>⛔</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    Quienes incurran en <strong>riñas, altercados violentos o conductas de acoso</strong>, ya sea entre usuarios o con algún funcionario de la Corporación Municipal de Deportes de Ñuñoa, su inscripción quedará caducada de forma inmediata, sin posibilidad de devolución del dinero.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Divider */}
                    <div className='border-t border-gray-200'></div>

                    {/* Sección 3: Normas de acceso */}
                    <section>
                        <h2 className='text-2xl md:text-3xl font-bold text-blue-700 mb-6 flex items-center gap-3'>
                            <span className='bg-blue-100 text-blue-700 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold'>2</span>
                            Normas de Acceso
                        </h2>
                        
                        <div className='space-y-4'>
                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    El ingreso a las dependencias de las personas adultas es sin acompañante, salvo que su movilidad requiera un apoyo.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    En el caso de niños y niñas, podrán ingresar acompañados solo de un adulto.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    En el caso de que un usuario ingrese acompañado de un menor de edad, es responsabilidad del adulto el cuidado del niño, niña o adolescente; aún cuando el adulto se encuentre en un taller.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Todo usuario debe entregar sus datos en la recepción para el ingreso o portar su tarjeta en caso de que corresponda.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    La Corporación Municipal de Deportes podrá cerrar o modificar los horarios de la oferta deportiva.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Es responsabilidad de los usuarios el buen uso del espacio deportivo y su equipamiento. En caso de dudas sobre el manejo de máquinas de ejercicios, debe consultar obligatoriamente al profesor o profesora especialista disponible.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Divider */}
                    <div className='border-t border-gray-200'></div>

                    {/* Sección 4: Sala de máquinas */}
                    <section>
                        <h2 className='text-2xl md:text-3xl font-bold text-purple-700 mb-6 flex items-center gap-3'>
                            <span className='bg-purple-100 text-purple-700 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold'>🏋️</span>
                            Sala de Máquinas
                        </h2>
                        
                        <div className='space-y-4'>
                            <div className='flex gap-3 bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500'>
                                <span className='text-purple-600 text-xl mt-1'>ℹ️</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    En la sala de máquinas <strong>no se brinda el servicio de personal trainer</strong> internos o externos. Contamos con instructores para evaluar, guiar y supervisar rutinas básicas para mejorar la condición física.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500'>
                                <span className='text-purple-600 text-xl mt-1'>⚠️</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    En caso de que se sorprenda a un usuario realizando este servicio, será cancelada su matrícula junto a la de la persona que contrató el servicio.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Divider */}
                    <div className='border-t border-gray-200'></div>

                    {/* Sección 5: Normas de inscripción */}
                    <section>
                        <h2 className='text-2xl md:text-3xl font-bold text-blue-700 mb-6 flex items-center gap-3'>
                            <span className='bg-blue-100 text-blue-700 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold'>3</span>
                            Normas de Inscripción
                        </h2>
                        
                        <div className='space-y-4'>
                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Las cuotas son <strong>individuales</strong> de cada usuario, sin la posibilidad de cederlas a otra persona. En ningún caso los usuarios podrán vender, ceder o transferir los derechos del servicio a otra persona singular o colectiva.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    En el caso de que se produzca esta infracción, se sancionará con la anulación de la suscripción sin reintegro de la cuota abonada.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Para la inscripción, cada usuario deberá ingresar todos sus datos, declarar su estado de salud e inscribir su RUT. En caso de ser vecino de Ñuñoa, tendrá un <strong>valor preferencial</strong> en la actividad inscrita.
                                </p>
                            </div>

                            <div className='flex gap-3 bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500'>
                                <span className='text-yellow-600 text-xl mt-1'>⚠️</span>
                                <p className='text-gray-800 leading-relaxed'>
                                    <strong>Importante:</strong> Aquellos usuarios que efectúen la inscripción con un RUT falso o de otro residente de la comuna, serán expulsados del taller, se bloqueará el RUT del sistema y se expondrán a posibles acciones legales por fraude.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Solo pueden acceder a las clases los usuarios que hayan abonado sus cuotas correspondientes al taller.
                                </p>
                            </div>

                            <div className='flex gap-3'>
                                <span className='text-blue-600 text-xl mt-1'>•</span>
                                <p className='text-gray-700 leading-relaxed'>
                                    Los usuarios se comprometen a respetar las normas de inscripción, así como el resto de las normas del servicio.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Divider */}
                    <div className='border-t border-gray-200'></div>

                    {/* Sección final: Derecho de admisión */}
                    <section>
                        <div className='bg-gray-100 p-6 rounded-lg border-l-4 border-gray-500'>
                            <p className='text-gray-800 leading-relaxed text-center'>
                                <strong>Derecho de Admisión:</strong> La Corporación Municipal de Deportes de Ñuñoa se reserva el derecho de admisión de personas que no mantengan las normas básicas de comportamiento social e higiene personal o evidencien un trato vejatorio hacia funcionarios de esta entidad.
                            </p>
                        </div>
                    </section>
                </div>

                {/* Footer */}
                <div className='mt-8 text-center text-gray-500 text-sm'>
                    <p>Corporación Municipal de Deportes de Ñuñoa</p>
                    <p>© 2025 - Todos los derechos reservados</p>
                </div>
            </div>
        </div>
    )
}

export default Privacy
